var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-page-table",class:{
    'is-full': _vm.full,
    'has-border': _vm.border,
    'is-scrollbar-fixed': _vm.scFixed
  }},[_c('div',{ref:"main",staticClass:"h-page-table__main"},[_vm._t("default"),(_vm.$slots.pagination)?[_c('div',{ref:"pagination",staticClass:"h-page-table__pagination",style:({ height: _vm.paginationAffix ? (_vm.pHeight + "px") : null })},[(_vm.paginationAffix)?_c('div',{ref:"affix",staticClass:"h-page-table__pagination--affix",style:({
            left: _vm.affixLeft,
            right: _vm.affixRight,
            bottom: (_vm.paginationOffsetBottom + "px")
          })},[_vm._t("pagination")],2):_vm._t("pagination")],2)]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }